import { render, staticRenderFns } from "./section-accordion-terms.vue?vue&type=template&id=76f9ea64&scoped=true"
import script from "./section-accordion-terms.vue?vue&type=script&lang=js"
export * from "./section-accordion-terms.vue?vue&type=script&lang=js"
import style0 from "./section-accordion-terms.vue?vue&type=style&index=0&id=76f9ea64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f9ea64",
  null
  
)

export default component.exports